import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.8,23.66l-3.59-4.88A11.325,11.325,0,0,0,27.5,13.5a11.5,11.5,0,0,0-23,0,11.325,11.325,0,0,0,1.29,5.28L2.2,23.66a.978.978,0,0,0-.13.96,1,1,0,0,0,.76.62l3.91.68,1.81,3.53a1.008,1.008,0,0,0,.81.55h.08a1,1,0,0,0,.8-.41l3.55-4.8a11.734,11.734,0,0,0,4.42,0l3.55,4.8a1,1,0,0,0,.8.41h.08a1.008,1.008,0,0,0,.81-.55l1.81-3.53,3.91-.68a1,1,0,0,0,.76-.62A.978.978,0,0,0,29.8,23.66ZM9.59,27.1,8.3,24.56a1,1,0,0,0-.72-.53l-2.81-.49,2.18-2.96a11.457,11.457,0,0,0,4.8,3.6Zm7.3-4.14a9.921,9.921,0,0,1-1.78,0A9.517,9.517,0,0,1,11.75,22a9.682,9.682,0,0,1-2.58-1.9,9.347,9.347,0,0,1-2-3.09,9.5,9.5,0,1,1,17.66,0,9.347,9.347,0,0,1-2,3.09A9.682,9.682,0,0,1,20.25,22,9.517,9.517,0,0,1,16.89,22.96Zm7.53,1.07a1,1,0,0,0-.72.53L22.41,27.1l-2.16-2.92a11.457,11.457,0,0,0,4.8-3.6l2.18,2.96Z"/><path d="M20.75,12.97c.44-.48.28-.97-.36-1.09L17.8,11.4,16.54,8.94c-.3-.59-.78-.59-1.08,0L14.2,11.4l-2.59.48c-.64.12-.8.61-.36,1.09l1.84,2-.37,2.78c-.08.64.32.93.91.63L16,17.18l2.37,1.2c.59.3.99.01.91-.63l-.37-2.78Z"/>';
export var AwardRibbonOutlineSVG = function AwardRibbonOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AwardRibbonOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AwardRibbonOutlineSVG);